import * as types from "./actionTypes";

export function setSearchLabel(searchLabel) {
    return { type: types.SET_SEARCH_LABEL, searchLabel };
}

export function setIsLoading(isLoading, isVisiblePagination = false) {
    return { type: types.SET_IS_LOADING, isLoading, isVisiblePagination };
}

export function setInitialData(initialData) {
    return { type: types.SET_INITIAL_DATA, initialData };
}

export function setDropdownType(selectedValue) {
    return { type: types.SET_DROPDOWN_TYPE, selectedValue };
}

export function setCategoriesData(categoriesData) {
    return { type: types.SET_CATEGORIES_DATA, categoriesData };
}

export function setCategory(category) {
    return { type: types.SET_CATEGORY, category };
}

export function setSitenameLabel(sitenameLabel) {
    return { type: types.SET_SITENAME_LABEL, sitenameLabel };
}

export function setSitename(sitename) {
    return { type: types.SET_SITENAME, sitename };
}

export function setSelectedCategory(selectedCategory) {
    return { type: types.SET_SELECTED_CATEGORY, selectedCategory };
}

export function setNavigationDetails(numberOfPages, selectedPage, navigation) {
    return { type: types.SET_NAVIGATION_DETAILS, numberOfPages, selectedPage, navigation };
}

export function setHidePromoted(hidePromoted) {
    return { type: types.HIDE_PROMOTED, hidePromoted };
}

export function setShowSitesFilter(showSitesFilter) {
    return { type: types.SET_SHOWSITESFILER, showSitesFilter };
}
